import { SET_COMPONENT_DATA } from './component-data-actions';

export const componentData = (state = {}, action = {}) => {
  if (action.type === SET_COMPONENT_DATA) {
    return { ...state, ...action.payload };
  } else {
    return state;
  }
};
